import { isoCountries } from '../../../assets/js/modules/constants';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

export function initializePhoneNumberInput($input) {
  const $parent = $input.closest('.iti');
  const isoCountryKeys = Object.keys(isoCountries);
  if (!$parent.hasClass('iti--show-flags')) {
    // eslint-disable-next-line no-undef
    const SFDCPhoneNumber = intlTelInput($input[0], {
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
      onlyCountries: isoCountryKeys,
      autoInsertDialCode: true,
      initialCountry: $input.data('selected-country'),
    });

    return SFDCPhoneNumber;
  }
}

export function setupPhoneInputEvents($input, $phoneNumber, $countryNameAdd) {
  const SFDCPhoneNumber = initializePhoneNumberInput($input);

  $input.on('countrychange', function () {
    const fullNumber = SFDCPhoneNumber.getNumber();
    const countryName = isoCountries[SFDCPhoneNumber.selectedCountryData.iso2.toUpperCase()];

    $phoneNumber.val(fullNumber);
    $countryNameAdd.val(countryName);
  });
}
